export class Run {
  constructor($location, $sce, $route, $rootScope, $timeout, $modal, AuthService, UserService, LikeService, BannerService, GiftService, socket, amMoment, ngMeta) {
    this.amMoment = amMoment;
    this.amMoment.changeLocale('es');
    this.location = $location;
    this.route = $route;
    this.ngMeta = ngMeta;
    this.rootScope = $rootScope;
    this.AuthService = AuthService;
    this.LikeService = LikeService;
    this.UserService = UserService;
    this.BannerService = BannerService;
    this.GiftService = GiftService;
    this.socket = socket;
    this.sce = $sce;
    this.modal = $modal;
    this.timeout = $timeout;
    this.rootScope.currentUserProfile = {};
    this.rootScope.showDeactiveModal = false;
    this.rootScope.current = {page: 'default'};
    this.rootScope.isLoggedIn = false;
    this.rootScope.chat_panel = false;
    this.rootScope.slidebars = new $.slidebars();
    this.rootScope.banner = {};
    this.rootScope.isPanelActivate = 0;
    this.rootScope.closingLeftPanel = false;
    this.rootScope.content = {items: [], page: 1, limit: 12, pageCount: 0, maxItem: 0, location: null};
    this.rootScope.originalPath = null;
    this.rootScope.counters = { chat: 0, like: 0, likeMe: 0, mutual: 0, visit: 0, recommended: 0 };
    this.rootScope.wizard = { messages: [], progress: 100 };
    this.rootScope.unregister = false
    this.init();
  }

  init() {
    this.ngMeta.init();

    //On connect
    this.socket.on('connect', () => {
      if(this.rootScope.currentUserProfile._id) {
        this.socket.emit('setUserID', JSON.stringify({userId: this.rootScope.currentUserProfile._id}));
        if(this.rootScope.chat_panel) {
          this.rootScope.$broadcast('refresh_chat');
        }
      }
    });

    this.socket.on(`update_chat`, (json_data) => {
      if(this.rootScope.chat_panel) {
        let data = JSON.parse(json_data);
        this.rootScope.$broadcast('update_chat', data.chat_room);
      }
    });

    this.socket.on(`counters`, (json_data) => {
      let data = JSON.parse(json_data);
      this.rootScope.counters = data;
    });

    this.rootScope.$on('$routeChangeStart', (event, current) => {
      $('.sb-site-container, .sb-slide').removeAttr('style');
      this.rootScope.slidebars.slidebars.css();
      this.rootScope.originalPath = current.originalPath;
      this.getBanner();
      this.getWizard();
    });

    this.rootScope.$on('$locationChangeSuccess', () => {
      if(this.location.path() === '/redirect') {
        this.AuthService.redirect();
      } else {
        this.AuthService.isAuthenticated();
      }
      if (typeof ga !== 'undefined') {
        ga('set', 'page', this.location.path());
        ga('send', 'pageview');
      }
    });

    this.rootScope.rulesModalOpen = () => {
      this.modal.open({
        templateUrl: '../../views/rules-modal.html',
        controller: 'RulesModalController'
      }).result.catch(angular.noop);
    };

    this.rootScope.getCurrentYear = () => {
      return new Date().getFullYear();
    };

    this.rootScope.zendeskWidget = () =>{
        zE(function() {
              zE.hide();
            })
        
        if(this.rootScope.getAge() >= 30  && this.rootScope.current.page == 'default'){
           zE(function() {
              zE.show();
            })
        }       
    }

    this.rootScope.isVip = () => {
      return this.rootScope.isLoggedIn
              && this.rootScope.currentUserProfile.usertype !== +'1'
              && this.rootScope.currentUserProfile.status
              && this.rootScope.currentUserProfile.payment
              && new Date(this.rootScope.currentUserProfile.payment.starting).getTime() <= Date.now()
              && new Date(this.rootScope.currentUserProfile.payment.ending).getTime() >= Date.now();
    };

    this.rootScope.paymentCount = () => {
      let count = 0;
      if(this.rootScope.currentUserProfile._id && !this.rootScope.isVip() && !this.rootScope.currentUserProfile.showPaymentCenterMessage) {
        count++;
      }
      return count;
    };

    this.rootScope.getVipTimes = () => {
      let times = 0;

      if(this.rootScope.isVip()) {
        times = new Date(this.rootScope.currentUserProfile.payment.ending).getTime() - Date.now();
      }

      return times > 0 ? times : 0;
    };

    this.rootScope.getStringVipTimes = () => {
      let times = this.rootScope.getVipTimes();
      times = Math.ceil(times / 1000 / 60 / 60);
      if(times <= 0) return `0 Días VIP`;
      if(times <= 48) return `${times} Horas VIP`;
      times = Math.ceil(times / 24);
      return `${times} Días VIP`;
    };

    this.rootScope.getAge = (user) => {
      if(!user) user = this.rootScope.currentUserProfile;
      let birthday = new Date(user.birthday);
      let dateNow = new Date();
      let age = dateNow.getYear() - birthday.getYear();
      let ageMonth = dateNow.getMonth() - birthday.getMonth();
      let ageDay = dateNow.getDate() - birthday.getDate();

      if(ageMonth < 0 || (ageMonth == 0 && ageDay < 0)) {
        age--;
      }

      return age;
    };

    this.rootScope.loadChatPanel = (userId, onlydisconnect, activeChat) => {
      if(onlydisconnect ||  activeChat){
        this.disconnect();
        return;
      }

      if(!this.rootScope.chat_panel){
        this.rootScope.slidebars.slidebars.toggle('right');
        this.rootScope.chat_panel = true;
        this.rootScope.$broadcast('open_chat_list', userId);
      } else {
        this.disconnect();
      }
    };

    this.rootScope.getWizard = () => {
      this.getWizard();
    };

    $(document).mouseup((e) => {
      let container = $("#slidebar_panel"),
          toastrContainer = $(".toast");

      if (!container.is(e.target)
          && container.has(e.target).length === 0
          && !toastrContainer.is(e.target)
          && toastrContainer.has(e.target).length === 0
          && !e.target.hasAttribute('toggle-chat')
          && this.rootScope.chat_panel) {
        this.disconnect();
      }
    });

    //for left panel
    this.rootScope.redirectTo = (page) => {
      this.timeout(() => {
        $('.sb-site-container, .sb-slide').removeAttr('style');
        this.rootScope.slidebars.slidebars.css();
        if(page) {
          this.location.path(page);
        }
      }, 450);
    };

    this.rootScope.isActive = (path) => {
      if (this.location.path().substr(0, path.length) === path) {
        return true;
      }
    };

    this.rootScope.getAvatar = (user, isOwnPage, size = '') => {
      return this.UserService.getAvatar(user, isOwnPage, size);
    };

    this.rootScope.getAlbumphoto = (url, size = '') => {
      return `/dating-album-photos/${url}${size}`;
    };

    this.rootScope.sumCounters = () => {
      return this.rootScope.counters ? ((this.rootScope.counters.chat || 0)
          + (this.rootScope.counters.likeMe || 0)
          + (this.rootScope.counters.mutual || 0)
          + (this.rootScope.counters.visit || 0)
          + (this.rootScope.counters.recommended || 0)) : 0;
    };

    this.rootScope.getCurrentUser = (callback) => {
      this.UserService.getCurrentUser()
        .then((response) => { let user = response.data;
          this.rootScope.currentUserProfile = user.data;
          this.zendeskWidgetScript()
          this.rootScope.zendeskWidget();
          this.socket.emit('setUserID', JSON.stringify({userId: this.rootScope.currentUserProfile._id}));
          if(typeof callback === 'function') {
            callback();
          }
        })
        .catch((response) => { let err = response.data;
          console.error(err);
          this.rootScope.unregister = true;  
          if(typeof callback === 'function') {
            callback();
          }
        });
    };

    this.rootScope.logout = (event) => {
      if (event && event.preventDefault) {
        event.preventDefault();
      }
      this.AuthService.logout();
    };

    this.rootScope.$watch(() => {
      return this.AuthService.isLoggedIn;
    }, (value) => {
      if(!value) return;
      this.rootScope.isLoggedIn = value;
      this.rootScope.getCurrentUser(() => {
        if (!this.rootScope.showDeactiveModal && this.rootScope.currentUserProfile.status === 0 && !this.rootScope.currentUserProfile.isBan) {
          this.rootScope.showDeactiveModal = true;
          this.modal.open({
            templateUrl: 'activateModal.html',
            controller: 'ActivateModalController'
          }).result.catch(angular.noop);
        }

        this.getBanner();
        this.getWizard();
        this.createRecommendation();
      })
    });

    this.rootScope.$watch(() => {
      return this.AuthService.isLoaded;
    }, (value) => {
      this.rootScope.current.isLoaded = value;
    });

    this.rootScope.$watch(() => {
      return (this.route.current && this.route.current.page) ? this.route.current.page : 'default';
    }, (value) => {
      this.rootScope.current.page = value;
    });
  }

  disconnect() {
    $('.accordion.email-list dd.active a.email-preview-container').click();
    $('a.userid_active').removeClass('userid_active');
    this.rootScope.slidebars.slidebars.close();
    this.rootScope.chat_panel = false;
  }

  getBanner() {
    if(_.isEmpty(this.rootScope.currentUserProfile) || !this.rootScope.originalPath) {
      return;
    }

    this.BannerService.getFilterBanners({id: this.rootScope.currentUserProfile._id, page: this.rootScope.originalPath})
    .then((response) => { let data = response.data;
      this.rootScope.banner = data.data;
      this.rootScope.banner.body = this.sce.trustAsHtml(this.rootScope.banner.body);
    })
    .catch((response) => { let err = response.data;
      console.error(err);
    });
  }

  getWizard() {
    if(_.isEmpty(this.rootScope.currentUserProfile)) {
      return;
    }

    this.GiftService.getWizard()
      .then((response) => { let data = response.data;
        this.rootScope.wizard = data.data;

        if(data.updated) {
          this.rootScope.getCurrentUser();
        }
      })
      .catch((response) => { let err = response.data;
        if(err) {
          console.error(err);
        }
      });
  }

  createRecommendation() {
    let user = this.rootScope.currentUserProfile;
    if(user._id && !user.recommendations || (!user.recommendations.countdown && !user.recommendations.users.length) || (user.recommendations.countdown && new Date(user.recommendations.countdown).getTime() < new Date().getTime())) {
      let request = {user: this.rootScope.currentUserProfile._id};
      this.UserService.createRecommendation(request)
        .then((_res) => { let response = _res.data;
          if(response.success){
            this.rootScope.currentUserProfile.recommendations = response.recommendations;
            this.socket.emit('counters');
          }
        })
        .catch((response) => { let err = response.data;
          console.error(err)
        });
    }
  }

  zendeskWidgetScript() {
    window.zEmbed||function(e,t){
  var n,o,d,i,s,a=[],
  r=document.createElement("iframe");
  window.zEmbed=function(){
    a.push(arguments)
  },
  window.zE=window.zE||window.zEmbed,
  r.src="javascript:false",
  r.title="",
  r.role="presentation",
  (r.frameElement||r).style.cssText="display: none",
  d=document.getElementsByTagName("script"),
  d=d[d.length-1],
  d.parentNode.insertBefore(r,d),
  i=r.contentWindow,
  s=i.document;
  try{
    o=s
  }catch(e){
    n=document.domain,
    r.src='javascript:var d=document.open();d.domain="'+n+'";void(0);',
    o=s
  }
  o.open()._l=function(){
    var e=this.createElement("script");
    n&&(this.domain=n),
    e.id="js-iframe-async",
    e.src="https://assets.zendesk.com/embeddable_framework/main.js",
    this.t=+new Date,
    this.zendeskHost="datingchile.zendesk.com",
    this.zEQueue=a,
    this.body.appendChild(e)
  },
  o.write('<body onload="document._l();">'),
  o.close()
}();
  }

}
